import { ProjectId } from 'api/models';
import { OnUserMention } from 'components/molecules/mention';
import { useSingleUserMentionHandler } from './use-invite-user';

interface UseOnUserMentionOptions {
  enabled?: boolean;
}
export const useOnUserMention = (
  projectId: ProjectId,
  options: UseOnUserMentionOptions = {},
): OnUserMention => {
  const handle = useSingleUserMentionHandler(projectId, options);

  return async (selected, callback) => {
    const response = await handle(selected.objectId ?? null);

    if (response) {
      callback(selected);
    }
  };
};
